import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import Format from 'app/src/data/Format';

export default class Sale extends RetailModel {
  // Server uses the saleLineID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'saleLineID';
  }

  get defaults() {
    return {
      createTime: '',
      timeStamp: '',
      unitQuantity: 0,
      unitPrice: 0.0,
      normalUnitPrice: 0.0,
      discountAmount: 0.0,
      discountPercent: 0.0,
      avgCost: 0.0,
      fifoCost: 0.0,
      tax: false,
      tax1Rate: 0.0,
      tax2Rate: 0.0,
      isLayaway: false,
      isWorkorder: false,
      isSpecialOrder: false,
      sortorder: '',
      onCompletedTrans: 0,
      calcLineDiscount: 0.0,
      calcTransactionDiscount: 0.0,
      calcTotal: 0.0,
      calcSubtotal: 0.0,
      calcTax1: 0.0,
      calcTax2: 0.0,
      taxClassID: 0,
      customerID: 0,
      discountID: 0,
      employeeID: 0,
      itemID: 0,
      noteID: 0,
      parentSaleLineID: 0,
      priceRuleID: 0,
      shopID: 0,
      taxCategoryID: 0,
      saleID: 0,
    };
  }

  get retailResponseName() {
    return 'SaleLine';
  }

  /**
   * Return the url for the SaleLine endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/SaleLine');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let parsedResponse = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    parsedResponse.saleLineID = Format.parseInt(parsedResponse.saleLineID);
    parsedResponse.unitQuantity = Format.parseInt(parsedResponse.unitQuantity);
    parsedResponse.unitPrice = Format.parseDecimal(parsedResponse.unitPrice);
    parsedResponse.normalUnitPrice = Format.parseDecimal(parsedResponse.normalUnitPrice);
    parsedResponse.discountAmount = Format.parseDecimal(parsedResponse.discountAmount);
    parsedResponse.discountPercent = Format.parseDecimal(parsedResponse.discountPercent);
    parsedResponse.avgCost = Format.parseDecimal(parsedResponse.avgCost);
    parsedResponse.fifoCost = Format.parseDecimal(parsedResponse.fifoCost);
    parsedResponse.tax = Format.parseBoolean(parsedResponse.tax);
    parsedResponse.tax1Rate = Format.parseDecimal(parsedResponse.tax1Rate);
    parsedResponse.tax2Rate = Format.parseDecimal(parsedResponse.tax2Rate);
    parsedResponse.isLayaway = Format.parseBoolean(parsedResponse.isLayaway);
    parsedResponse.isWorkorder = Format.parseBoolean(parsedResponse.isWorkorder);
    parsedResponse.isSpecialOrder = Format.parseBoolean(parsedResponse.isSpecialOrder);
    parsedResponse.onCompletedTrans = Format.parseInt(parsedResponse.onCompletedTrans);
    parsedResponse.calcLineDiscount = Format.parseDecimal(parsedResponse.calcLineDiscount);
    parsedResponse.calcTransactionDiscount = Format.parseDecimal(
      parsedResponse.calcTransactionDiscount
    );
    parsedResponse.calcTotal = Format.parseDecimal(parsedResponse.calcTotal);
    parsedResponse.calcSubtotal = Format.parseDecimal(parsedResponse.calcSubtotal);
    parsedResponse.calcTax1 = Format.parseDecimal(parsedResponse.calcTax1);
    parsedResponse.calcTax2 = Format.parseDecimal(parsedResponse.calcTax2);
    parsedResponse.taxClassID = Format.parseInt(parsedResponse.taxClassID);
    parsedResponse.customerID = Format.parseInt(parsedResponse.customerID);
    parsedResponse.discountID = Format.parseInt(parsedResponse.discountID);
    parsedResponse.employeeID = Format.parseInt(parsedResponse.employeeID);
    parsedResponse.itemID = Format.parseInt(parsedResponse.itemID);
    parsedResponse.noteID = Format.parseInt(parsedResponse.noteID);
    parsedResponse.parentSaleLineID = Format.parseInt(parsedResponse.parentSaleLineID);
    parsedResponse.priceRuleID = Format.parseInt(parsedResponse.priceRuleID);
    parsedResponse.shopID = Format.parseInt(parsedResponse.shopID);
    parsedResponse.taxCategoryID = Format.parseInt(parsedResponse.taxCategoryID);
    parsedResponse.saleID = Format.parseInt(parsedResponse.saleID);

    return parsedResponse;
  }
}
